module.exports = __webpack_public_path__ + "static/img/y29.b80c13f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y29.jpg
// module id = xnqk
// module chunks = 1